import store from '@/app/store/store';

export function hasActiveFund(to, from, next) {
  if (to.matched.some(record => record.meta.requiresStore)) {
    if (store.getters['fund/hasFund']) {
      next();
    } else {
      next({
        path: '/',
      });
    }
  } else {
    next();
  }
}

export default hasActiveFund;
